import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: window.sessionStorage.getItem("token") || "",
    spbs: window.sessionStorage.getItem("spbs"),
    title: window.sessionStorage.getItem("title") || "法律服务管理系统",
    quanxian: (() => {
      const stored = window.sessionStorage.getItem("quanxian");
      if (!stored || stored === "admin" || stored === "xianzhi") {
        return stored || "admin";
      }
      try {
        return JSON.parse(stored);
      } catch (e) {
        return stored;
      }
    })(),
  },
  getters: {
    GET_TOKEN: (state) => state.token,
    GET_TITLE: (state) => state.title,
    GET_SPBS: (state) => state.spbs,
    GET_QUANXIAN: (state) => state.quanxian,
  },
  mutations: {
    INIT_TOKEN(state, token) {
      state.token = token;
      window.sessionStorage.setItem("token", token);
    },
    INIT_SPBS(state, spbs) {
      state.spbs = spbs;
      window.sessionStorage.setItem("spbs", spbs);
    },
    INIT_QUANXIAN(state, quanxian) {
      state.quanxian = quanxian;
      // 如果是数组或对象，需要序列化存储
      const quanxianStr =
        typeof quanxian === "object" ? JSON.stringify(quanxian) : quanxian;
      window.sessionStorage.setItem("quanxian", quanxianStr);
    },
    INIT_TITLE(state, title) {
      state.title = title;
      window.sessionStorage.setItem("title", title);
    },
  },
  actions: {},
  modules: {},
});
